import { inject, Injectable } from '@angular/core';
import { MbscResource } from '@mobiscroll/angular';
import {
  DetailEmployee,
  LoadRosterDetailParams,
  LoadRosterResourceParams,
  RosterResourceRepository,
} from '@softapps/pms/roster';
import { ApiDataAccess } from '@softline/core';
import { SOFTLINE_API_DELIVERY_NOTE_ROSTER_STRUCTURE } from '../delivery-note-roster.api';
import { RosterDeliveryStructure } from '../types/roster-delivery-structure';

@Injectable()
export class DeliveryNoteRosterResourceRepository extends RosterResourceRepository<
  MbscResource,
  DetailEmployee
> {
  readonly #dataAccess = inject(ApiDataAccess);

  async load(_params: LoadRosterResourceParams): Promise<MbscResource[]> {
    const items = await this.#dataAccess.get<RosterDeliveryStructure[]>({
      path: SOFTLINE_API_DELIVERY_NOTE_ROSTER_STRUCTURE,
    });
    return items.map((item) => ({
      id: item.id,
      name: item.name,
      key: item.key,
      eventCreation: true,
    }));
  }

  async loadDetail(_params: LoadRosterDetailParams): Promise<DetailEmployee> {
    return {} as DetailEmployee;
  }
}
